module.exports = __webpack_public_path__ + "img/settings.fd20cf35.svg";